








import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class Counter extends Vue {
    @Prop({default: 10}) value!: number
    @Prop({default: 10}) minimumCount!: number
    internalValue: number = null

    created() {
        this.internalValue = this.value
    }

    @Watch('value')
    updateInternalValue() {
        if (this.internalValue !== this.value) {
            this.internalValue = this.value
        }
    }

    // copy value to internal value on create; watch for changes
    @Watch('internalValue')
    onValueChanged() {
        const value = this.internalValue
        this.$emit('input', value)
    }
}
